module.exports = __webpack_public_path__ + "static/media/WhipAround_ios_2.cd1a5696.jpg";